import React from 'react';
import {Link} from 'react-router-dom';
import {SecondaryButton} from '../../components';

export default function QuickActionsCard({
  heading,
  paragraph,
  linkText,
  className = '',
  link = '/',
  disabled = false,
}) {
  const cardContent = (
    <div
      className={`pt-7 px-6 pb-6 shadow-cards bg-white border-[0.5px] border-[#D9E5F8] hover:border-brandBlue ${className} transition-all duration-200 ${
        disabled ? 'opacity-50 pointer-events-none' : 'cursor-pointer'
      }`}
    >
      <h3 className="text-deepBlue mb-4 text-base lg:text-[18px] font-semibold">
        {heading}
      </h3>
      <p className="text-sm mb-4 h-10 font-normal text-[#858DAA]">
        {paragraph}
      </p>
      <SecondaryButton buttonText={linkText} />
    </div>
  );

  return disabled ? (
    cardContent
  ) : (
    <Link to={link} className="block">
      {cardContent}
    </Link>
  );
}
